import React from 'react'

import Select from '../../../../../../../../1stlog-ui/src/components/Select'

const UnitSelect = (props) => {
  const {} = props

  const options = [
    {
      value: 'kg',
      label: i18n.t('label_kg', 'kg'),
    },
    {
      value: 'l',
      label: i18n.t('label_litre', 'Liter'),
    },
  ]

  return <Select {...props} options={options} direct hideDropdown />
}

export default UnitSelect
